module.exports = __webpack_public_path__ + "assets/img/btn-view-all-0ccd4eda.png";